<template>
    <div class="container">
        <el-form ref="formRef" :rules="rules" :model="form" label-width="150px" >
            <div class="formTitle">修改密码</div>
            <el-row>
                <el-form-item label="原始密码" prop="oldPwd">
                    <el-input type="password" placeholder="原始密码" v-model="form.oldPwd" show-password></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="新密码" prop="newPwd">
                    <el-input type="password" placeholder="新密码" v-model="form.newPwd" show-password></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="确认新密码" prop="comfirnNewPwd">
                    <el-input type="password" placeholder="确认新密码" v-model="form.comfirnNewPwd" show-password></el-input>
                </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onSubmit" type="primary">提交</el-button>
            <el-button @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
import {userServiceApi} from '@/api/api-auth';
import {checkPwd} from  '@/assets/js/validator';
import {clearUser } from '@/assets/js/user';

export default {
    data(){
        return {
            form:{},
            rules: {
                oldPwd: [{ required: true, trigger: 'blur',message:"不能为空" }],
                newPwd: [{ required: true, trigger: 'blur', validator:checkPwd }],
                comfirnNewPwd: [{ required: true, trigger: 'blur',message:"不能为空"}]
            }
        }
    },
    methods:{
        onSubmit(){
            this.$refs.formRef.validate((valid)=>{
                if(!valid){
                    return;
                }
                if(this.form.newPwd !== this.form.comfirnNewPwd){
                    this.$message.error("确认新密码不一致");
                    return;
                }
                userServiceApi.resetMyPwd({newPwd:this.form.newPwd,oldPwd:this.form.oldPwd}).then(res=>{
                    if(res.result){
                        this.$message.success("修改成功");
                        setTimeout(()=>{
                            clearUser();
                            this.$router.push('/login');
                        },1000)
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            });
        },
        onCancel(){
            this.form = {};
        },
    }
}
</script>

<style lang='less' scoped>
    .el-form{
        width: 430px;
        margin:0 auto;
    }
    .formTitle{
        font-weight:800px;
        font-size:25px;
        text-align:center;
        margin:0px 0px 30px 0px;
        padding-top:20px;
    }
</style>